export const LOGO_FF_COULEUR_URL = `${import.meta.env.BASE_URL}/logos/logo_france_frais_connect_v2.png`;
